<template>
  <a-modal
      title="添加专家信息"
      :visible="editVisible"
      :maskClosable="false"
      width="80vw" centered
      destroyOnClose
      :footer="null"
      @cancel="editVisible=false">
    <expert-form ref="addForm" @success="addSuccess"/>
  </a-modal>
</template>

<script>

import expertForm from '@/epp/expertmain/expertInfo/common/ExpertForm.vue'

export default {
  name: 'ExpertAdd',
  components: {
    expertForm
  },
  props: {},
  data () {
    return {
      editVisible: false
    }
  },
  computed: {},
  created () {
  },
  methods: {
    async loadData () {
      this.editVisible = true
    },
    addSuccess () {
      this.editVisible = false
      this.$emit('success')
    }
  }
}
</script>

<style></style>
